import { companyBranchConfigsApi } from "./branchConfigsApi";
import { companyPayrollRunsApi } from "./payrollRunsApi";

/**
 * After a payroll setting is saved, refetch what the run wizard derived from
 * the old value: each branch's `readiness` (served on the branch-config list)
 * and the wizard's period options.
 *
 * WHY (R22): those live in different RTK Query slices from the settings that
 * feed them — policies, country rules and SIF banks each have their own
 * `createApi` — and `invalidatesTags` cannot cross a slice. So saving a policy
 * or deactivating a SIF bank left the readiness chip and the wizard's periods
 * on their cached values until a full reload, and the wizard could offer a run
 * the server then refused.
 *
 * Used as `onQueryStarted` on those mutations; it waits for success, since a
 * failed save changed nothing.
 */
export const syncPayrollReadiness = async (
  _arg: unknown,
  {
    dispatch,
    queryFulfilled,
  }: {
    dispatch: (action: unknown) => unknown;
    queryFulfilled: Promise<unknown>;
  },
) => {
  try {
    await queryFulfilled;
  } catch {
    return;
  }
  dispatch(companyBranchConfigsApi.util.invalidateTags(["branchConfigs"]));
  dispatch(companyPayrollRunsApi.util.invalidateTags(["payrollPeriodOptions"]));
};
